import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Link } from 'react-router';
import type { Location } from 'history';
import { useIntl } from 'react-intl';
import getReportPages from 'pages/Report/utils/getReportPages';
import Select from 'pages/Report/components/Select';
import SelectItem from 'pages/Report/components/Select/components/SelectItem';
import { Typography } from '@material-ui/core';

interface ComponentProps {
  location: Location;
}

const Navigation: React.FunctionComponent<ComponentProps> = (props) => {
  const { location } = props;
  const classes = useStyles(props);
  const intl = useIntl();

  const renderValue = () => intl.formatMessage({ id: 'report.navigation.title' });

  return (
    <Select
      closeOnSelect
      renderValue={renderValue}
      buttonProps={{
        classes: {
          outlinedPrimary: classes.outlinedPrimary,
          iconSizeMedium: classes.iconSizeMedium
        }
      }}
      menuProps={{
        MenuListProps: { disablePadding: true }
      }}
    >
      {getReportPages(intl).map((page, i) => {
        const itemProps = page.link
          ? {
              component: Link,
              to: { pathname: page.link, search: !page.isStartPage && location.search }
            }
          : {};
        return (
          <SelectItem
            key={`${page.title}${i}`}
            divider={page.divider}
            disabled={page.disabled}
            {...itemProps}
          >
            <Typography>{page.title}</Typography>
          </SelectItem>
        );
      })}
    </Select>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    paper: {
      marginTop: 2
    },
    roundedPaper: {
      borderRadius: 5
    },
    outlinedPrimary: {
      borderColor: theme.palette.grey.A700,

      '& .MuiButton-endIcon': {
        color: theme.palette.primary.light
      },

      '&:hover': {
        borderColor: theme.palette.primary.light,

        '& .MuiButton-endIcon': {
          color: theme.palette.primary.main
        }
      }
    },
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  })
);

export default Navigation;
